import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEye, faStar, faFileExcel, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './EvaluacionesData.css';
import baseURL from '../../url';
import * as XLSX from 'xlsx';

export default function EvaluacionesData() {
    const [evaluaciones, setEvaluaciones] = useState([]);
    const [stats, setStats] = useState({
        promedio: 0,
        total: 0,
        distribucion: [],
        temporal: []
    });
    const [modalDetalleVisible, setModalDetalleVisible] = useState(false);
    const [evaluacionActual, setEvaluacionActual] = useState({});
    const [encuestaActiva, setEncuestaActiva] = useState(true);

    // Filtros
    const [filtroTexto, setFiltroTexto] = useState('');
    const [filtroFechaInicio, setFiltroFechaInicio] = useState('');
    const [filtroFechaFin, setFiltroFechaFin] = useState('');
    const [filtroRating, setFiltroRating] = useState('');

    useEffect(() => {
        cargarEvaluaciones();
        cargarEstadisticas();
        cargarConfiguracion();
    }, []);

    useEffect(() => {
        aplicarFiltros();
        cargarEstadisticas();
    }, [filtroTexto, filtroFechaInicio, filtroFechaFin, filtroRating]);

    const cargarEvaluaciones = () => {
        fetch(`${baseURL}/evaluacionGet.php`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setEvaluaciones(data.evaluaciones || []);
                }
            })
            .catch(error => console.error('Error al cargar evaluaciones:', error));
    };

    const cargarEstadisticas = () => {
        const params = new URLSearchParams();
        if (filtroFechaInicio) params.append('date_from', filtroFechaInicio);
        if (filtroFechaFin) params.append('date_to', filtroFechaFin);

        fetch(`${baseURL}/evaluacionStats.php?${params.toString()}`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setStats(data);
                }
            })
            .catch(error => console.error('Error al cargar estadísticas:', error));
    };

    const cargarConfiguracion = () => {
        fetch(`${baseURL}/configGet.php`)
            .then(response => response.json())
            .then(data => {
                if (data.success && data.config) {
                    setEncuestaActiva(data.config.evaluacion_activo === 1 || data.config.evaluacion_activo === '1');
                }
            })
            .catch(error => console.error('Error al cargar configuración:', error));
    };

    const aplicarFiltros = () => {
        const params = new URLSearchParams();
        if (filtroTexto) params.append('q', filtroTexto);
        if (filtroFechaInicio) params.append('date_from', filtroFechaInicio);
        if (filtroFechaFin) params.append('date_to', filtroFechaFin);
        if (filtroRating) params.append('rating', filtroRating);

        fetch(`${baseURL}/evaluacionGet.php?${params.toString()}`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setEvaluaciones(data.evaluaciones || []);
                }
            })
            .catch(error => console.error('Error al aplicar filtros:', error));
    };

    const toggleEncuesta = async () => {
        const nuevoEstado = !encuestaActiva;
        
        try {
            const response = await fetch(`${baseURL}/evaluacionToggle.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ activo: nuevoEstado ? 1 : 0 })
            });

            const data = await response.json();
            
            if (data.success) {
                setEncuestaActiva(nuevoEstado);
                toast.success(data.message);
            } else {
                toast.error(data.error || 'Error al actualizar configuración');
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error al actualizar configuración');
        }
    };

    const eliminarEvaluacion = (idEvaluacion) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Esta acción no se puede revertir",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/evaluacionDelete.php`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ idEvaluacion })
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            Swal.fire('¡Eliminado!', data.message, 'success');
                            cargarEvaluaciones();
                            cargarEstadisticas();
                        } else {
                            toast.error(data.error);
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        toast.error('Error al eliminar evaluación');
                    });
            }
        });
    };

    const verDetalle = (evaluacion) => {
        setEvaluacionActual(evaluacion);
        setModalDetalleVisible(true);
    };

    const limpiarFiltros = () => {
        setFiltroTexto('');
        setFiltroFechaInicio('');
        setFiltroFechaFin('');
        setFiltroRating('');
    };

    const exportarExcel = () => {
        const datosExportar = evaluaciones.map(e => ({
            'ID': e.idEvaluacion,
            'Pedido ID': e.idPedido,
            'Rating': e.rating,
            'Cliente': e.nombreCliente || 'N/A',
            'Comentario': e.comentario || '',
            'Fecha': e.createdAt
        }));

        const ws = XLSX.utils.json_to_sheet(datosExportar);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Evaluaciones');
        XLSX.writeFile(wb, `Evaluaciones_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    const renderStars = (rating) => {
        return (
            <div className="stars-display">
                {[1, 2, 3, 4, 5].map((star) => (
                    <FontAwesomeIcon
                        key={star}
                        icon={star <= rating ? faStar : faStarRegular}
                        className={star <= rating ? 'star-filled-display' : 'star-empty-display'}
                    />
                ))}
            </div>
        );
    };

    const formatearFecha = (fechaISO) => {
        if (!fechaISO) return '';
        const fecha = new Date(fechaISO);
        return fecha.toLocaleString('es-ES', { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className="evaluacionesDataContainer">
            <ToastContainer />
            
            <div className="evaluacionesHeader">
                <h2>Evaluaciones de Clientes</h2>
                <div className="headerActions">
                    <button 
                        className={`btnToggle ${encuestaActiva ? 'activo' : 'inactivo'}`}
                        onClick={toggleEncuesta}
                        title={encuestaActiva ? 'Desactivar encuesta' : 'Activar encuesta'}
                    >
                        <FontAwesomeIcon icon={encuestaActiva ? faToggleOn : faToggleOff} />
                        {encuestaActiva ? ' Encuesta Activa' : ' Encuesta Inactiva'}
                    </button>
                    <button className="btnExportar" onClick={exportarExcel}>
                        <FontAwesomeIcon icon={faFileExcel} /> Exportar Excel
                    </button>
                </div>
            </div>

            {/* Estadísticas rápidas */}
            <div className="statsCards">
                <div className="statsCard">
                    <div className="statsCardIcon">⭐</div>
                    <div className="statsCardContent">
                        <h3>{stats.promedio.toFixed(1)}</h3>
                        <p>Promedio de Rating</p>
                    </div>
                </div>
                <div className="statsCard">
                    <div className="statsCardIcon">📊</div>
                    <div className="statsCardContent">
                        <h3>{stats.total}</h3>
                        <p>Total de Evaluaciones</p>
                    </div>
                </div>
                <div className="statsCard">
                    <div className="statsCardIcon">😍</div>
                    <div className="statsCardContent">
                        <h3>{stats.distribucion.find(d => d.rating === 5)?.cantidad || 0}</h3>
                        <p>5 Estrellas</p>
                    </div>
                </div>
            </div>

            {/* Gráficos */}
            <div className="graficosContainer">
                {/* Gráfico de distribución */}
                <div className="grafico">
                    <h3>Distribución de Ratings</h3>
                    <div className="barrasContainer">
                        {stats.distribucion.slice().reverse().map((item) => {
                            const maxValor = Math.max(...stats.distribucion.map(d => d.cantidad), 1);
                            const porcentaje = (item.cantidad / maxValor) * 100;
                            
                            return (
                                <div key={item.rating} className="barraItem">
                                    <div className="barraLabel">
                                        {item.rating} ⭐
                                    </div>
                                    <div className="barraWrapper">
                                        <div 
                                            className="barra" 
                                            style={{ width: `${porcentaje}%` }}
                                            title={`${item.cantidad} evaluaciones`}
                                        ></div>
                                    </div>
                                    <div className="barraValor">{item.cantidad}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Gráfico temporal */}
                <div className="grafico">
                    <h3>Ratings en el Tiempo</h3>
                    <div className="lineChartContainer">
                        {stats.temporal.length > 0 ? (
                            <div className="lineChart">
                                {stats.temporal.map((punto, index) => {
                                    const maxRating = 5;
                                    const promedioDia = parseFloat(punto.promedio_dia) || 0;
                                    const altura = (promedioDia / maxRating) * 100;
                                    
                                    return (
                                        <div key={index} className="lineChartPoint">
                                            <div 
                                                className="lineChartBar"
                                                style={{ height: `${altura}%` }}
                                                title={`${new Date(punto.fecha).toLocaleDateString()}: ${promedioDia.toFixed(1)} ⭐`}
                                            >
                                                <span className="lineChartValue">{promedioDia.toFixed(1)}</span>
                                            </div>
                                            <div className="lineChartLabel">
                                                {new Date(punto.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <p className="noData">No hay datos para mostrar</p>
                        )}
                    </div>
                </div>
            </div>

            {/* Filtros */}
            <div className="filtrosEvaluaciones">
                <input
                    type="text"
                    placeholder="Buscar en comentarios..."
                    value={filtroTexto}
                    onChange={(e) => setFiltroTexto(e.target.value)}
                    className="filtroInput"
                />
                <input
                    type="date"
                    value={filtroFechaInicio}
                    onChange={(e) => setFiltroFechaInicio(e.target.value)}
                    className="filtroInput"
                />
                <input
                    type="date"
                    value={filtroFechaFin}
                    onChange={(e) => setFiltroFechaFin(e.target.value)}
                    className="filtroInput"
                />
                <select
                    value={filtroRating}
                    onChange={(e) => setFiltroRating(e.target.value)}
                    className="filtroInput"
                >
                    <option value="">Todos los ratings</option>
                    <option value="5">5 estrellas</option>
                    <option value="4">4 estrellas</option>
                    <option value="3">3 estrellas</option>
                    <option value="2">2 estrellas</option>
                    <option value="1">1 estrella</option>
                </select>
                <button className="btnLimpiarFiltros" onClick={limpiarFiltros}>
                    Limpiar Filtros
                </button>
            </div>

            {/* Tabla */}
            <div className="table-container">
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Pedido</th>
                            <th>Rating</th>
                            <th>Cliente</th>
                            <th>Comentario</th>
                            <th>Fecha</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {evaluaciones.length > 0 ? (
                            evaluaciones.map(evaluacion => (
                                <tr key={evaluacion.idEvaluacion}>
                                    <td>{evaluacion.idEvaluacion}</td>
                                    <td>#{evaluacion.idPedido}</td>
                                    <td>{renderStars(evaluacion.rating)}</td>
                                    <td>{evaluacion.nombreCliente || 'N/A'}</td>
                                    <td title={evaluacion.comentario}>
                                        {evaluacion.comentario 
                                            ? (evaluacion.comentario.length > 50 
                                                ? evaluacion.comentario.substring(0, 50) + '...' 
                                                : evaluacion.comentario)
                                            : '-'}
                                    </td>
                                    <td>{formatearFecha(evaluacion.createdAt)}</td>
                                    <td>
                                        <button 
                                            className="btnAccion btnVer" 
                                            onClick={() => verDetalle(evaluacion)}
                                            title="Ver detalle"
                                        >
                                            <FontAwesomeIcon icon={faEye} />
                                        </button>
                                        <button 
                                            className="btnAccion btnEliminar" 
                                            onClick={() => eliminarEvaluacion(evaluacion.idEvaluacion)}
                                            title="Eliminar"
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center', padding: '2rem' }}>
                                    No hay evaluaciones registradas
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal Detalle */}
            {modalDetalleVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>Detalle de la Evaluación</h3>
                            <span className="close" onClick={() => setModalDetalleVisible(false)}>&times;</span>
                        </div>
                        <div className="modal-body">
                            <div className="detalleEvaluacion">
                                <p><strong>ID Evaluación:</strong> {evaluacionActual.idEvaluacion}</p>
                                <p><strong>ID Pedido:</strong> #{evaluacionActual.idPedido}</p>
                                <div>
                                    <strong>Rating:</strong>
                                    {renderStars(evaluacionActual.rating)}
                                </div>
                                <p><strong>Cliente:</strong> {evaluacionActual.nombreCliente || 'N/A'}</p>
                                <p><strong>Email:</strong> {evaluacionActual.emailCliente || 'N/A'}</p>
                                <p><strong>Teléfono:</strong> {evaluacionActual.telefonoCliente || 'N/A'}</p>
                                <div>
                                    <strong>Comentario:</strong>
                                    <p className="comentarioCompleto">{evaluacionActual.comentario || 'Sin comentario'}</p>
                                </div>
                                <p><strong>Fecha:</strong> {formatearFecha(evaluacionActual.createdAt)}</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btnCancelar" onClick={() => setModalDetalleVisible(false)}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

